"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILManageStudentOverdue = exports.RenderManageOverdueForm = exports.SubmittedMessage = exports.RenderCoursesAssignment = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var il_card_assignment_1 = require("../il-card-assignment/il-card-assignment");
var il_student_header_1 = require("../il-student-header/il-student-header");
var reschedule_activity_1 = require("../reschedule-activity/reschedule-activity");
var typeography_common_1 = require("../typeography/typeography.common");
var icon_config_1 = require("../../configs/icon.config");
var FormSavedSvg = icon_config_1.IconDefinitions.FORM_SAVED;
function RenderCoursesAssignment(_a) {
    var coursesAssignment = _a.coursesAssignment, onReschedule = _a.onReschedule, sx = _a.sx;
    return (react_1.default.createElement(material_1.Box, { className: "assignment-list", sx: __assign({ maxWidth: { xs: 'auto', sm: 'auto', md: '50%', lg: '50%' }, mx: '1.5rem', mb: '1rem', mt: '1rem' }, sx) }, coursesAssignment.map(function (courseAssignment) { return (react_1.default.createElement(material_1.Box, { key: courseAssignment.courseId },
        react_1.default.createElement(material_1.Box, { sx: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
            } },
            react_1.default.createElement(typeography_common_1.ILBody2, { sx: { fontSize: '0.9375rem', fontWeight: 'bold' } }, courseAssignment.courseName),
            react_1.default.createElement(material_1.Button, { variant: "text", sx: { fontWeight: 'normal' }, onClick: function () {
                    onReschedule && onReschedule(courseAssignment);
                } }, "Reschedule")),
        react_1.default.createElement(material_1.List, { sx: {
                display: 'flex',
                flexDirection: 'column',
                pt: 0,
            } }, courseAssignment.assignmentProps.map(function (assignment, idx) { return (react_1.default.createElement(material_1.ListItem, { key: idx, sx: {
                justifyContent: 'center',
                my: 0,
                py: '0.25rem',
                px: 0,
                '& .MuiCard-root': {
                    borderWidth: '0.0625rem',
                    borderRadius: '0.25rem',
                    borderColor: 'action.disabledBackground',
                    borderStyle: 'solid',
                    width: '100%',
                },
            } },
            react_1.default.createElement(il_card_assignment_1.IlCardAssignment, __assign({}, assignment, { clickable: false })))); })))); })));
}
exports.RenderCoursesAssignment = RenderCoursesAssignment;
function SubmittedMessage(props) {
    return (react_1.default.createElement(material_1.Box, { sx: __assign({ px: '3rem', flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center', mt: '-1rem' }, props.sx) },
        react_1.default.createElement(material_1.SvgIcon, { titleAccess: "Success", viewBox: "0 0 73 107", sx: { width: '5rem', height: '7rem', mb: '0.5rem' } },
            react_1.default.createElement(FormSavedSvg, null)),
        react_1.default.createElement(typeography_common_1.ILBody1, { sx: {
                color: 'text.primary',
                fontWeight: 'bold',
                textAlign: 'center',
            } }, "Success!"),
        react_1.default.createElement(typeography_common_1.ILBody1, { sx: {
                color: 'text.secondary',
                textAlign: 'center',
            } }, "Your student's course is back on track!"),
        props.children));
}
exports.SubmittedMessage = SubmittedMessage;
function RenderManageOverdueForm(_a) {
    var _b = _a.submitted, submitted = _b === void 0 ? false : _b, _c = _a.submittedMessage, submittedMessage = _c === void 0 ? react_1.default.createElement(SubmittedMessage, null) : _c, selectedAssigment = _a.selectedAssigment, averageAssignmentsPerDay = _a.averageAssignmentsPerDay, dateStartYear = _a.dateStartYear, dateEndYear = _a.dateEndYear, defaultFormValues = _a.defaultFormValues, onSubmit = _a.onSubmit, props = __rest(_a, ["submitted", "submittedMessage", "selectedAssigment", "averageAssignmentsPerDay", "dateStartYear", "dateEndYear", "defaultFormValues", "onSubmit"]);
    return (react_1.default.createElement(material_1.Box, { className: "reschedule-form", sx: __assign({ backgroundColor: 'background.paper', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', pt: '1rem', px: '1.5rem', form: {
                width: '100%',
            } }, props.sx) },
        submitted && submittedMessage,
        !submitted && (react_1.default.createElement(react_1.default.Fragment, null,
            !selectedAssigment && (react_1.default.createElement(typeography_common_1.ILBody1, { sx: {
                    color: 'text.secondary',
                    textAlign: 'center',
                    px: { xs: '1rem', sm: '2rem', md: '3rem', lg: '3rem', xl: '3rem' },
                } }, "Select a course to make adjustments to it`s schedule.")),
            !!selectedAssigment && (react_1.default.createElement(reschedule_activity_1.RescheduleActivityForm, { activityDescription: selectedAssigment.assignmentProps[0].courseTitle, averageAssignmentsPerDay: averageAssignmentsPerDay, dateStartYear: dateStartYear, dateEndYear: dateEndYear, defaultFormValues: defaultFormValues, onSubmit: onSubmit, showModalHeader: true, dateLabel: "Remaining Work" }))))));
}
exports.RenderManageOverdueForm = RenderManageOverdueForm;
function ILManageStudentOverdue(_a) {
    var className = _a.className, sx = _a.sx, studentProps = _a.studentProps, title = _a.title, props = __rest(_a, ["className", "sx", "studentProps", "title"]);
    return (react_1.default.createElement(material_1.Box, { className: 'il-manage-students-overdue ' + className, sx: __assign({}, sx) },
        !!title && (react_1.default.createElement(material_1.Box, { sx: {
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                mb: '1.5rem',
                mt: '1rem',
            } },
            react_1.default.createElement(typeography_common_1.ILH3, { sx: { fontSize: { xs: '1.15rem', sm: '1.375rem' } } }, title))),
        react_1.default.createElement(il_student_header_1.IlStudentHeader, __assign({}, studentProps, { sx: { mx: '1.5rem' } })),
        react_1.default.createElement(material_1.Divider, { sx: {
                mt: '1rem',
            } }),
        react_1.default.createElement(material_1.Box, { className: "content", sx: {
                display: 'flex',
                flexDirection: 'row',
            } },
            react_1.default.createElement(RenderCoursesAssignment, __assign({}, props)),
            react_1.default.createElement(RenderManageOverdueForm, __assign({}, props)))));
}
exports.ILManageStudentOverdue = ILManageStudentOverdue;
